export enum TabType {
	create,
	details,
	list,
}
